import { Form } from "react-bootstrap";
import React, { useState, useEffect } from "react";
import { Load } from "../load/load";
import { actualizaDeshabilitarServicios } from "../../api/servicios";
import { toast } from "react-toastify";
import { LogsInformativos } from "../logs/logs";

export default function CancelarServicio({ data, history, setShow }) {
  console.log(data);

  const idDocumental = data[0];

  const dataTemp = {
    pieza: data[1],
    clasificacion: data[2],
  };

  console.log(data)

  const [formData, setFormData] = useState(initialFormValue(dataTemp));

  //load
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simula una carga de datos
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, []);

  //insert
  const onSubmit = (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      // Sube a cloudinary la imagen principal del producto

      const dataTemp = {
        estado: "0"
      }

      actualizaDeshabilitarServicios(idDocumental, dataTemp).then((response) => {
        const { data } = response;
        //notificacion
        LogsInformativos("Se ha cancelado el servicio " + idDocumental, dataTemp)
        toast.success(data.mensaje);

        setLoading(false);
        setShow(false);
        //cancelarRegistro()
      });
    } catch (e) {
      console.log(e);
    }
  };

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <>
      {loading && <Load />}
      <div className='generalEstablecimiento'>
        <Form className='formEstablecimiento' onSubmit={onSubmit} onChange={onChange}>
          <Form.Group>
            <Form.Label className='lblTelefono'>Pieza: </Form.Label>
            <Form.Control
              type='text'
              className='inpTelefono'
              placeholder='Ingresa modelo'
              defaultValue={formData.pieza}
              name="pieza"
              disabled
            />
          </Form.Group>
          <Form.Group className='lblTelefono'>
            <Form.Label className='lblEmail'>Clasificacion: </Form.Label>
            <Form.Control
              type='text'
              className='inpNombreEst'
              placeholder='placa'
              defaultValue={formData.clasificacion}
              name="clasificacion"
              disabled
            />
          </Form.Group>
          <br />
          <label></label>
          <div className="divSubmit">
            <input className="submit" value="Enviar" type="submit" />
          </div>
        </Form>
      </div>
    </>
  );
}

function initialFormValue(data) {
  return {
    pieza: data.pieza,
    clasificacion: data.clasificacion,
  };
}
